{
	"backToManageDeclarations": "Terug naar Verklaringen beheren",
	"kpi": {
		"quantity": "Hoeveelheid",
		"carbonSavings": "CO\u2082-reducties"
	},
	"downloadAllDeclarations": "Alle verklaringen downloaden",
	"errors": {
		"notFound": "Project niet gevonden"
	}
}
